import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LocalStorageModule } from 'angular-2-local-storage';

import { AppComponent } from './app.component';

import { HttpModule } from '@angular/http';

import { TranslateService } from './services/translate.service';
import { TranslatePipe } from './translate.pipe';

import { CommunicationService } from './services/communication.service';
import { ProfileService } from './services/profile.service';
import { AuthenticationService } from './services/authentication.service';
import { NaviService } from './services/navi.service';
import { HCPStatisticService } from './services/hcpstatistic.service';
import { GroupService } from './services/group.service';
import { HCPGroupService } from './services/hcpgroup.service';
import { UserService } from './services/user.service';
import { HcpQuestionnaireService } from './services/hcp-questionnaire.service';
import { PatientQuestionnaireService } from './services/patient-questionnaire.service';
import { MessageService } from './services/message.service';
import { AlarmService } from './services/alarm.service';
import { RegisterService } from './services/register.service';
import { UserStatisticsService } from './services/user-statistics.service';

import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NaviComponent } from './components/navi/navi.component';
import { NaviTopComponent } from './components/navi-top/navi-top.component';
import { GroupComponent } from './components/group/group.component';
import { GroupDetailsComponent } from './components/group-details/group-details.component';
import { FooterComponent } from './components/footer/footer.component';
import { GroupDetailsMemberComponent } from './components/group-details-member/group-details-member.component';
import { GroupDetailsCollaboratorComponent } from './components/group-details-collaborator/group-details-collaborator.component';
import { GroupDetailsStatisticsComponent } from './components/group-details-statistics/group-details-statistics.component';
import { MyGroupsComponent } from './components/my-groups/my-groups.component';
import { GroupDetailsNavComponent } from './components/group-details-nav/group-details-nav.component';
import { CollaboratingStudiesComponent } from './components/collaborating-studies/collaborating-studies.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { LandingpageComponent } from './components/landingpage/landingpage.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ImprintComponent } from './components/imprint/imprint.component';
import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';
import { HcpDashboardComponent } from './components/hcp-dashboard/hcp-dashboard.component';
import { HcpNaviComponent } from './components/hcp-navi/hcp-navi.component';
import { GroupDetailsPatientComponent } from './components/group-details-patient/group-details-patient.component';
import { MyQuestionnairesComponent } from './components/my-questionnaires/my-questionnaires.component';
import { QuestionnaireDetailsComponent } from './components/questionnaire-details/questionnaire-details.component';
import { HcpMessagingListComponent } from './components/hcp-messaging-list/hcp-messaging-list.component';
import { HcpMessagingNewComponent } from './components/hcp-messaging-new/hcp-messaging-new.component';
import { HcpMessagingDetailComponent } from './components/hcp-messaging-detail/hcp-messaging-detail.component';
import { HCPAlarmsListComponent } from './components/hcpalarms-list/hcpalarms-list.component';
import { HcpPatientDetailComponent } from './components/hcp-patient-detail/hcp-patient-detail.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { ForgotpasswordComponent } from './components/forgotpassword/forgotpassword.component';
import { VerificationCompletedComponent } from './components/verification-completed/verification-completed.component';
import { SetNewPasswordComponent } from './components/set-new-password/set-new-password.component';
import { PatientMessagingListComponent } from './components/patient-messaging-list/patient-messaging-list.component';
import { PatientMessagesDetailComponent } from './components/patient-messages-detail/patient-messages-detail.component';
import { LandingpageFooterComponent } from './components/landingpage-footer/landingpage-footer.component';
import { PatientMessagesNewComponent } from './components/patient-messages-new/patient-messages-new.component';
import { InvitesComponent } from './components/invites/invites.component';
import { InviteService } from 'app/services/invite.service';
import { UserStatisticsComponent } from './components/user-statistics/user-statistics.component';

@NgModule({
  declarations: [
    AppComponent,
    TranslatePipe,
    LoginComponent,
    DashboardComponent,
    NaviComponent,
    NaviTopComponent,
    GroupComponent,
    GroupDetailsComponent,
    FooterComponent,
    GroupDetailsMemberComponent,
    GroupDetailsCollaboratorComponent,
    GroupDetailsStatisticsComponent,
    MyGroupsComponent,
    GroupDetailsNavComponent,
    CollaboratingStudiesComponent,
    MyProfileComponent,
    LandingpageComponent,
    AboutUsComponent,
    ImprintComponent,
    DisclaimerComponent,
    HcpDashboardComponent,
    HcpNaviComponent,
    GroupDetailsPatientComponent,
    MyQuestionnairesComponent,
    QuestionnaireDetailsComponent,
    HcpMessagingListComponent,
    HcpMessagingNewComponent,
    HcpMessagingDetailComponent,
    HCPAlarmsListComponent,
    HcpPatientDetailComponent,
    RegistrationComponent,
    ForgotpasswordComponent,
    VerificationCompletedComponent,
    SetNewPasswordComponent,
    PatientMessagingListComponent,
    PatientMessagesDetailComponent,
    LandingpageFooterComponent,
    PatientMessagesNewComponent,
    InvitesComponent,
    UserStatisticsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot([
      {
        path: '',
        component: LandingpageComponent
      },
      {
        path: 'index',
        component: LandingpageComponent
      },
      {
        path: 'index.html',
        component: LandingpageComponent
      },
      {
        path: 'about',
        component: AboutUsComponent
      },
      {
        path: 'imprint',
        component: ImprintComponent
      },
      {
        path: 'disclaimer',
        component: DisclaimerComponent
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'group-details',
        component: GroupDetailsComponent
      },
      {
        path: 'groups',
        component: GroupComponent
      },
      {
        path: 'group-details-member',
        component: GroupDetailsMemberComponent
      },
      {
        path: 'hcp/managing-groups/:id/detail',
        component: GroupDetailsComponent
      },
      {
        path: 'hcp/managing-groups/:id/members',
        component: GroupDetailsMemberComponent
      },
      {
        path: 'hcp/managing-groups/:id/collaborators',
        component: GroupDetailsCollaboratorComponent
      },
      {
        path: 'hcp/managing-groups/:id/statistics',
        component: GroupDetailsStatisticsComponent
      },
      {
        path: 'group-details-statistics',
        component: GroupDetailsStatisticsComponent
      },
      {
        path: 'mygroups',
        component: MyGroupsComponent
      },
      {
        path: 'hcp/managing-groups',
        component: CollaboratingStudiesComponent
      },
      {
        path: 'my-profile',
        component: MyProfileComponent
      },
      {
        path: 'hcp/dashboard',
        component: HcpDashboardComponent
      },
      {
        path: 'mygroups/:id',
        component: GroupDetailsPatientComponent
      },
      {
        path: 'mygroups/:id/statistics',
        component: UserStatisticsComponent
      },
      {
        path: 'groups/:id',
        component: GroupDetailsPatientComponent
      },
      {
        path: 'myquestionnaires',
        component: MyQuestionnairesComponent
      },
      {
        path: 'myquestionnaires/:id',
        component: QuestionnaireDetailsComponent
      },
      {
        path: 'hcp/messages',
        component: HcpMessagingListComponent
      },
      {
        path: 'hcp/messages/new',
        component: HcpMessagingNewComponent
      },
      {
        path: 'hcp/messages/:id',
        component: HcpMessagingDetailComponent
      },
      {
        path: 'messages',
        component: PatientMessagingListComponent
      },
      {
        path: 'messages/new',
        component: PatientMessagesNewComponent
      },
      {
        path: 'messages/:id',
        component: PatientMessagesDetailComponent
      },
      {
        path: 'hcp/alarms',
        component: HCPAlarmsListComponent
      },
      {
        path: 'hcp/members/:id',
        component: HcpPatientDetailComponent
      },
      {
        path: 'hcp/members/:id/studies/:sid',
        component: HcpPatientDetailComponent
      },
      {
        path: 'registration',
        component: RegistrationComponent
      },
      {
        path: 'forgot-password',
        component: ForgotpasswordComponent
      },
      {
        path: 'email/user/verify',
        component: VerificationCompletedComponent
      },
      {
        path: 'email/user/reverify',
        component: VerificationCompletedComponent
      },
      {
        path: 'email/password/reset',
        component: SetNewPasswordComponent
      },
      {
        path: 'invitations',
        component: InvitesComponent
      }
    ]),
    LocalStorageModule.withConfig({
      prefix: 'sivantos',
      storageType: 'localStorage'
    })
  ],
  providers: [
    NaviService,
    TranslateService,
    ProfileService,
    CommunicationService,
    AuthenticationService,
    HCPStatisticService,
    GroupService,
    HCPGroupService,
    UserService,
    HcpQuestionnaireService,
    PatientQuestionnaireService,
    MessageService,
    AlarmService,
    RegisterService,
    UserStatisticsService,
    InviteService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/app.module.ts